export const BENTO_BANNER_DEFAULT_IMAGE = {
  src: '/images/bento/banner-illustration.png',
  width: 273,
  height: 56,
} as const;
